import { Dispatch, SetStateAction } from 'react';
import { SecondaryButton } from '../../../../../../components/SecondaryButton';
import { Card } from './styles';

interface CheckingCardI {
  checkingDate?: string;
  setFinishCheckingModalShow: Dispatch<SetStateAction<boolean>>;
}

export default function CheckingCard({ setFinishCheckingModalShow, checkingDate }: CheckingCardI) {
  return (
    <Card>
      <div className="card-title">
        <div>Conferência</div>
      </div>

      <>
        <div className="card-main" style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-around',
          alignItems: 'center',
          height: '100%',
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
            <div style={{fontSize: '16px'}}>
              {checkingDate ?? 'Conferência não finalizada'}
            </div>
            {checkingDate && (
              <small>
                  Data da conferência
              </small>
            )}
          </div>

          {!checkingDate && (
            <div style={{fontSize: '12px'}}>
              <SecondaryButton onClick={() => setFinishCheckingModalShow(true)}>
                  Finalizar Conferência
              </SecondaryButton>
            </div>
          )}
        </div>
      </>
    </Card>
  );
}
